import { useState } from 'react';
import { pinProblem } from '@tradeoutlet/shared';
import { api, errorMessage } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';
import { useUi } from '@/lib/store';
import { Button, Field, Input, Modal } from '@/components/ui';

/** t712u: Set PIN for someone (Clock-in tab). Same rules as their own PIN; entered twice; never shown again. */
export function SetPinDialog({ userId, name, onClose, onSaved }: { userId: string; name: string; onClose: () => void; onSaved: () => void }) {
  const ws = useWorkspaceId();
  const toast = useUi(s => s.toast);
  const [pin, setPin] = useState('');
  const [pin2, setPin2] = useState('');
  const [busy, setBusy] = useState(false);
  const problem = pin ? pinProblem(pin) : null;
  const mismatch = pin2.length >= pin.length && pin2 !== '' && pin !== pin2;
  const save = async () => {
    setBusy(true);
    try { await api.wf.setKioskPinFor(ws!, userId, pin); toast('PIN saved', 'success'); onSaved(); onClose(); } catch (e) { toast(errorMessage(e), 'error'); } finally { setBusy(false); }
  };
  const digits = (v: string) => v.replace(/\D/g, '').slice(0, 6);
  return (
    <Modal open onClose={onClose} title={`Set kiosk PIN for ${name}`}
      footer={<><Button variant="ghost" onClick={onClose}>Cancel</Button><Button loading={busy} disabled={!pin || Boolean(problem) || pin !== pin2} onClick={() => void save()} data-testid="person-pin-save">Save</Button></>}>
      <div className="space-y-3" data-testid="person-pin-dialog">
        <Field label="New PIN" hint="4 to 6 digits"><Input type="password" inputMode="numeric" autoComplete="new-password" value={pin} onChange={e => setPin(digits(e.target.value))} data-testid="person-pin-new" /></Field>
        <Field label="Type it again"><Input type="password" inputMode="numeric" autoComplete="new-password" value={pin2} onChange={e => setPin2(digits(e.target.value))} data-testid="person-pin-again" /></Field>
        {(problem || mismatch) && <p className="text-sm text-rose-700" role="alert">{problem ?? 'The PINs don’t match'}</p>}
        <p className="text-xs text-slate-500">Tell {name} their PIN in person. It isn’t shown again, and they can change it in the app.</p>
      </div>
    </Modal>
  );
}
